import React from "react";

const Account = () => {
  return (
    <div className="w-full h-[800px] bg-[#0a292f]">
      <div className="w-full h-[600px] py-40 flex justify-center items-center bg-[#0a292f] text-white">
        <p className="text-white text-4xl bg-blue-500 flex flex-col items-center justify-center">
          Welcome ;
        </p>
        <div>
          <button className="text-center items-center flex justify-center  rounded-lg px-6 py-3 m-2 bg-black">
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Account;
